/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { BuilderUserContext } from '@gh/builder-shared';
import { CONTACT_TYPE_EMPLOYEE } from '@gh/builder-shared-data';
import { createContextRoute } from '@gh/common-internal-shared';
import {
  ContactDetailsBusinessService,
  ContactDetailsEmployeeCommonTabComponent,
  ContactDetailsSharedCommunicationListTabComponent,
  ContactDetailsSharedCustomFieldsTabComponent,
  ContactDetailsSharedTermsPayeeTabComponent,
} from '../../index';
import { ContactDetailsModel } from '../../services/contact-details-model.service';
import { ContactDetailsEmployeeFormDelegator } from './contact-details-employee-form.service';

@Component({
  standalone: false,
  selector: 'gh-contact-details-employee-tab',
  templateUrl: 'contact-details-employee-tab.component.html',
})
export class ContactDetailsEmployeeTabComponent {
  url: any;

  routes = [
    createContextRoute({
      component: ContactDetailsEmployeeCommonTabComponent,
      path: 'common',
      init: {
        service: ContactDetailsBusinessService,
        selector: 'initEmployeeCommonTabView',
      },
    }),
    createContextRoute({
      component: ContactDetailsSharedCommunicationListTabComponent,
      path: 'communications',
      init: {
        service: ContactDetailsBusinessService,
        selector: 'initSharedCommunicationsTabView',
      },
      static: {
        tab: 'employee',
        contactType: CONTACT_TYPE_EMPLOYEE,
      },
    }),
    createContextRoute({
      component: ContactDetailsSharedTermsPayeeTabComponent,
      path: 'terms',
      init: {
        service: ContactDetailsBusinessService,
        selector: 'initSharedTermsPayeeTabView',
      },
      static: {
        tab: 'employee',
      },
    }),
    createContextRoute({
      component: ContactDetailsSharedCustomFieldsTabComponent,
      path: 'customFields',
      static: {
        tab: 'employee',
      },
    }),
  ];

  constructor(public model: ContactDetailsModel,
              public form: ContactDetailsEmployeeFormDelegator,
              public userContext: BuilderUserContext) {
  }

  get currentTab(): string {
    return <string>this.model.getSlaveTabFor('employee');
  }

  onTabChanged(name: string): void {
    this.model.goToSubTab(name);
  }
}
